import { UnfoldIcon } from 'components/icons'
import classNames from 'helpers/class-names'
import { ChangeEvent, Dispatch, FC, Ref } from 'react'
import { ComboboxOption, ComboboxOptions } from 'ui'

interface Props {
  setSelected: Dispatch<any>
  selected?: ComboboxOption
  options: ComboboxOptions
  id: string
  className?: string
  name: string
  optionValue?: (option: ComboboxOption) => string
  selectRef: Ref<any>
  onFocus?: any
  onBlur?: any
  variant: 'compact' | 'normal' | 'large' | 'display'
  disabled?: boolean
}

const Select: FC<Props> = ({
  id,
  setSelected,
  selected,
  options,
  className,
  name,
  optionValue,
  selectRef,
  onFocus,
  onBlur,
  variant = 'normal',
  disabled,
}) => {
  const handleChange = (
    event: ChangeEvent<HTMLSelectElement>,
    options: ComboboxOptions,
  ) => {
    options.map((option) => {
      if ('name' in option) {
        handleChange(event, option.options)
      } else {
        if (String(option.id) === String(event.target.value)) {
          setSelected(option)
        }
      }
    })
  }

  return (
    <div className={classNames('text-base')}>
      <div className="relative">
        <select
          className={classNames(`appearance-none`, className, {
            'cursor-not-allowed bg-gray-50': disabled,
          })}
          id={id}
          ref={selectRef}
          name={name}
          value={selected?.id || ''}
          onChange={(event) => handleChange(event, options)}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}>
          {options.map((option) =>
            'name' in option ? (
              <optgroup key={option.name} label={option.name}>
                {option.options.map((groupOption) => (
                  <option
                    key={`${id}-${groupOption.id}`}
                    value={groupOption.id}>
                    {!optionValue
                      ? groupOption.value
                      : optionValue(groupOption)}
                  </option>
                ))}
              </optgroup>
            ) : (
              <option key={`${id}-${option.id}`} value={option.id}>
                {!optionValue ? option.value : optionValue(option)}
              </option>
            ),
          )}
        </select>
        <span
          className={classNames(
            'pointer-events-none absolute inset-y-0 right-0 flex items-center',
            { 'mr-px mt-px pr-1 pt-0.5': variant === 'compact' },
            { 'mr-px pr-1': variant === 'normal' },
          )}>
          <UnfoldIcon
            className={classNames('text-gray-300', {
              'animate-pulse cursor-not-allowed select-none text-gray-100':
                disabled,
              'size-4': variant === 'normal',
              'size-3': variant === 'compact',
            })}
            aria-hidden="true"
          />
        </span>
      </div>
    </div>
  )
}

export default Select
